"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEventTracker = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactRouterDom = require("react-router-dom");

var _ = require("./");

var _types = require("../types");

var _getDataLayerElements = require("../utils/getDataLayerElements");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _content = require("../context/content");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useEventTracker = function useEventTracker() {
  var _useContextProvider = (0, _.useContextProvider)(),
      state = _useContextProvider.state,
      config = _useContextProvider.config;

  var onEvent = (0, _.useOnEvent)();
  var location = (0, _reactRouterDom.useLocation)();
  return function (event, override) {
    var payload = _objectSpread({
      event: {
        category: event.category || 'poi-component',
        action: event.action,
        location: event.location || location.pathname.substr(1),
        label: (0, _get2.default)((0, _content.getDefaultContent)(config.countryCode), event.label, event.label),
        pageTitle: event.pageTitle || 'bank_connect'
      }
    }, (0, _getDataLayerElements.getDataLayerElements)(state, override));

    onEvent({
      type: _types.FiConnectEventTypes.ANALYTICS,
      data: payload
    });
    return payload;
  };
};

exports.useEventTracker = useEventTracker;